jQuery(document).ready(function($) {

	function isTouchEnabled() {
		return ( 'ontouchstart' in window ) || 
			   ( navigator.maxTouchPoints > 0 ) || 
			   ( navigator.msMaxTouchPoints > 0 );
	}

	$('.map-location-item-close').on('click', function() {

		$('.map-location-item-meta').removeClass('active');
		console.log('close');

	})

	const touchEnabled = isTouchEnabled();

	if (touchEnabled) {

		$('.map-location-item button').on('click', function() {

			console.log('click');
	
			const $this = $(this);
			const id = $this.data('id');
	
			const selector = $(`#item-${id}-meta`);
	
			$('.map-location-item-meta').removeClass('active');
	
			selector.addClass('active');
	
			const thisWidth = selector.outerWidth();
			const thisLeft = selector.offset().left;
			const windowWidth = $(window).outerWidth();
	
			const totalOffset = thisLeft + thisWidth;
	
			if (totalOffset > windowWidth) {
				const diff = windowWidth - totalOffset;
				selector.css({
					'--offset-left': `${diff}px`,
				});
			}
	
			console.log({
				thisWidth,
				thisLeft,
				windowWidth
			});
	
		})		

	} else {
		$('.map-location-item button').on('mouseenter', function() {

			console.log('mouseenter');
	
			const $this = $(this);
			const id = $this.data('id');
	
			const selector = $(`#item-${id}-meta`);
	
			$('.map-location-item-meta').removeClass('active');
	
			selector.addClass('active');
	
			const thisWidth = selector.outerWidth();
			const thisLeft = selector.offset().left;
			const windowWidth = $(window).outerWidth();
	
			const totalOffset = thisLeft + thisWidth;
	
			if (totalOffset > windowWidth) {
				const diff = windowWidth - totalOffset;
				selector.css({
					'--offset-left': `${diff}px`,
				});
			}
	
			console.log({
				thisWidth,
				thisLeft,
				windowWidth
			});
	
		}).on('mouseleave', function() {
	
			//e.preventDefault();
			console.log('mouseleave');
	
			const $this = $(this);
			const id = $this.data('id');
	
			const selector = $(`#item-${id}-meta`);
	
			selector.removeClass('active');
	
		});
	}




});